const en = {
  eyebrow: 'About us',
  title: 'A small studio with a big love for celebrations',
  intro:
    'Flores con Aroma de Café is a bilingual floral and balloon decoration studio based in Jessup, Maryland. We design, build and install decorations for the days families remember forever.',
  story: {
    title: 'Our story',
    paragraphs: [
      'It started with flowers — bouquets for friends, centerpieces for family parties, and the joy of watching a room transform. Word spread, and weddings and quinceañeras followed.',
      'As our clients asked for more, we added balloon artistry: organic garlands, arches and themed backdrops. Today we’re one of the few local studios that designs flowers and balloons together, so every element of your event feels like it belongs.',
    ],
  },
  expertise: {
    title: 'Two crafts, one eye for detail',
    flowers: {
      title: 'Floral design',
      text: 'Wedding bouquets, ceremony arches, centerpieces and custom arrangements built with seasonal blooms sourced fresh the week of your event.',
    },
    balloons: {
      title: 'Balloon artistry',
      text: 'Organic garlands, full arches, themed installations and character setups — assembled on site in the exact colors of your celebration.',
    },
  },
  mission: {
    title: 'Our mission',
    text: 'To make every celebration feel luxurious and personal — whatever the budget — with honest pricing, bilingual care, and decorations that arrive early and stay perfect.',
  },
  area: {
    title: 'Where we work',
    text: 'Based in Jessup and serving a 15-mile radius across Howard, Anne Arundel and Prince George’s County. Farther away? Ask us — we travel for special events.',
    towns: ['Jessup', 'Columbia', 'Laurel', 'Elkridge', 'Ellicott City', 'Odenton', 'Hanover', 'Savage'],
  },
  imageAlt: 'Outdoor quinceañera with pink tables, floral centerpieces and a pink and gold balloon backdrop',
  imageAlt2: 'Sage green wedding sweetheart table beneath a blush hydrangea floral arch',
}

const es: typeof en = {
  eyebrow: 'Nosotros',
  title: 'Un estudio pequeño con un gran amor por las celebraciones',
  intro:
    'Flores con Aroma de Café es un estudio bilingüe de decoración floral y con globos en Jessup, Maryland. Diseñamos, creamos e instalamos decoraciones para los días que las familias recuerdan para siempre.',
  story: {
    title: 'Nuestra historia',
    paragraphs: [
      'Todo comenzó con flores — ramos para amigas, centros de mesa para fiestas familiares y la alegría de ver un salón transformarse. Se corrió la voz, y llegaron las bodas y quinceañeras.',
      'Cuando nuestros clientes pidieron más, sumamos el arte de los globos: guirnaldas orgánicas, arcos y fondos temáticos. Hoy somos uno de los pocos estudios locales que diseña flores y globos juntos, para que cada detalle de su evento combine.',
    ],
  },
  expertise: {
    title: 'Dos artes, un mismo ojo para el detalle',
    flowers: {
      title: 'Diseño floral',
      text: 'Ramos de novia, arcos de ceremonia, centros de mesa y arreglos personalizados con flores de temporada conseguidas frescas la semana de su evento.',
    },
    balloons: {
      title: 'Arte con globos',
      text: 'Guirnaldas orgánicas, arcos completos, instalaciones temáticas y montajes de personajes — armados en el lugar con los colores exactos de su celebración.',
    },
  },
  mission: {
    title: 'Nuestra misión',
    text: 'Hacer que cada celebración se sienta lujosa y personal — sin importar el presupuesto — con precios honestos, atención bilingüe y decoraciones que llegan temprano y se mantienen perfectas.',
  },
  area: {
    title: 'Dónde trabajamos',
    text: 'Con base en Jessup, servimos un radio de 15 millas en los condados de Howard, Anne Arundel y Prince George’s. ¿Más lejos? Pregúntenos — viajamos para eventos especiales.',
    towns: ['Jessup', 'Columbia', 'Laurel', 'Elkridge', 'Ellicott City', 'Odenton', 'Hanover', 'Savage'],
  },
  imageAlt: 'Quinceañera al aire libre con mesas rosas, centros de mesa florales y fondo de globos rosa y oro',
  imageAlt2: 'Mesa de novios verde salvia bajo un arco floral de hortensias rubor',
}

export const about = { en, es }
